module.exports = "/static/assets/d44a4ea3b3b168cf5212ee949f4f33d1.png";